import React, { useState, useEffect } from "react";
import Productgrid from "../Homepage/Productgrid";
import leftTree from "../../assets/images/left-tree.png";
import righttree from "../../assets/images/right-tree.png";
import Slider from "react-slick";
import axios from "axios";
import { apiurl } from "../../Constants";
import "@fortawesome/fontawesome-free/css/all.min.css";

function SpecialProducts() {
  const [activeStick, setActiveStick] = useState(""); // To manage the active stick button
  const [gridactive, setGridactive] = useState("");

  // Set initial grid class and active stick based on screen size
  useEffect(() => {
    const mediaQuery991 = window.matchMedia("(max-width: 991px)");
    const mediaQuery767 = window.matchMedia("(max-width: 767px)");
    const mediaQuery575 = window.matchMedia("(max-width: 575px)");

    // Function to set the appropriate grid layout and stick button
    const handleScreenChange = () => {
      if (mediaQuery575.matches) {
        // Below 575px: Activate single-grid and the corresponding stick button

        setActiveStick("stick_two");
        setGridactive("grid_two");
        setSlidersettings((prevSettings) => ({
          ...prevSettings,
          slidesToShow: 2,
        }));
      } else if (mediaQuery767.matches) {
        // Below 767px: Activate two-grid and the corresponding stick button

        setActiveStick("stick_two");
        setGridactive("grid_two");
        setSlidersettings((prevSettings) => ({
          ...prevSettings,
          slidesToShow: 2,
        }));
      } else if (mediaQuery991.matches) {
        setActiveStick("stick_three");
        setGridactive("grid_three");
        setSlidersettings((prevSettings) => ({
          ...prevSettings,
          slidesToShow: 3,
        }));
      } else {
        // Web: Activate four-grid and the corresponding stick button

        setActiveStick("stick_six");
        setGridactive("grid_six");
        setSlidersettings((prevSettings) => ({
          ...prevSettings,
          slidesToShow: 6,
        }));
      }
    };

    handleScreenChange();
    mediaQuery575.addEventListener("change", handleScreenChange);
    mediaQuery767.addEventListener("change", handleScreenChange);
    mediaQuery991.addEventListener("change", handleScreenChange);

    return () => {
      mediaQuery575.removeEventListener("change", handleScreenChange);
      mediaQuery767.removeEventListener("change", handleScreenChange);
      mediaQuery991.removeEventListener("change", handleScreenChange);
    };
  }, []);

  // Stick button handlers
  function stickhandleone() {
    setActiveStick("stick_one");
    setGridactive("grid_one");
    setSlidersettings((prevSettings) => ({
      ...prevSettings,
      slidesToShow: 1,
    }));
  }

  function stickhandletwo() {
    setActiveStick("stick_two");
    setGridactive("grid_two");
    setSlidersettings((prevSettings) => ({
      ...prevSettings,
      slidesToShow: 2,
    }));
  }

  function stickhandlethree() {
    setActiveStick("stick_three");
    setGridactive("grid_three");
    setSlidersettings((prevSettings) => ({
      ...prevSettings,
      slidesToShow: 3,
    }));
  }

  function stickhandlefour() {
    setActiveStick("stick_four");
    setGridactive("grid_four");
    setSlidersettings((prevSettings) => ({
      ...prevSettings,
      slidesToShow: 4,
    }));
  }

  function stickhandlesix() {
    setActiveStick("stick_six");
    setGridactive("grid_six");
    setSlidersettings((prevSettings) => ({
      ...prevSettings,
      slidesToShow: 6,
    }));
  }

  const CustomPrevArrow = ({ onClick }) => {
    return (
      <button className="custom-prev-arrow" onClick={onClick}>
        <i className="fa-solid fa-arrow-left"></i>
      </button>
    );
  };

  const CustomNextArrow = ({ onClick }) => {
    return (
      <button className="custom-next-arrow" onClick={onClick}>
        <i className="fa-solid fa-arrow-right"></i>
      </button>
    );
  };

  const [sliderSettings, setSlidersettings] = useState({
    infinite: true,
    loop: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    margin: 8,
    nav: true,
    autoplay: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  });

  const [specialProducts, setSpecialProducts] = useState([]);
  

  useEffect(() => {
  
        const fetchSpecialproducts = async () => {
          try {
            const response = await axios.post(apiurl + "special_products");
            setSpecialProducts(response.data.products);
          } catch (error) {
            console.log(error);
          }
        };
        fetchSpecialproducts();
    
  }, []);

  return (
    <section className="new_products_section related-products-section col_divide_design pt-40 pb-40">
      <div className="container">
        <div className="row first_row">
          <div className="col-xl-3 col-lg-3 main-stick-inner">
            {specialProducts.length > 3 ? (
              <div className="main-stick">
                <div
                  onClick={stickhandleone}
                  className={`${
                    activeStick === "stick_one"
                      ? "active-bg-grid"
                      : "sticks-inner-box"
                  } stick_one`}
                >
                  <button
                    className={
                      activeStick === "stick_one"
                        ? "stickhandleone-one"
                        : "stick-color"
                    }
                  ></button>
                </div>
                <div
                  onClick={stickhandletwo}
                  className={`${
                    activeStick === "stick_two"
                      ? "active-bg-grid"
                      : "sticks-inner-box"
                  } stick_two`}
                >
                  <button
                    className={
                      activeStick === "stick_two"
                        ? "stickhandleone-two"
                        : "stick-color"
                    }
                  ></button>
                  <button
                    className={
                      activeStick === "stick_two"
                        ? "stickhandleone-two"
                        : "stick-color"
                    }
                  ></button>
                </div>
                <div
                  onClick={stickhandlethree}
                  className={`${
                    activeStick === "stick_three"
                      ? "active-bg-grid"
                      : "sticks-inner-box"
                  } stick_three`}
                >
                  <button
                    className={
                      activeStick === "stick_three"
                        ? "stickhandleone-three"
                        : "stick-color"
                    }
                  ></button>
                  <button
                    className={
                      activeStick === "stick_three"
                        ? "stickhandleone-three"
                        : "stick-color"
                    }
                  ></button>
                  <button
                    className={
                      activeStick === "stick_three"
                        ? "stickhandleone-three"
                        : "stick-color"
                    }
                  ></button>
                </div>
                <div
                  onClick={stickhandlefour}
                  className={`${
                    activeStick === "stick_four"
                      ? "active-bg-grid"
                      : "sticks-inner-box"
                  } stick_four`}
                >
                  <button
                    className={
                      activeStick === "stick_four"
                        ? "stickhandleone-four"
                        : "stick-color"
                    }
                  ></button>
                  <button
                    className={
                      activeStick === "stick_four"
                        ? "stickhandleone-four"
                        : "stick-color"
                    }
                  ></button>
                  <button
                    className={
                      activeStick === "stick_four"
                        ? "stickhandleone-four"
                        : "stick-color"
                    }
                  ></button>
                  <button
                    className={
                      activeStick === "stick_four"
                        ? "stickhandleone-four"
                        : "stick-color"
                    }
                  ></button>
                </div>
                <div
                  onClick={stickhandlesix}
                  className={`${
                    activeStick === "stick_six"
                      ? "active-bg-grid"
                      : "sticks-inner-box"
                  } stick_five`}
                >
                  <button
                    className={
                      activeStick === "stick_six"
                        ? "stickhandleone-five"
                        : "stick-color"
                    }
                  ></button>
                  <button
                    className={
                      activeStick === "stick_six"
                        ? "stickhandleone-five"
                        : "stick-color"
                    }
                  ></button>
                  <button
                    className={
                      activeStick === "stick_six"
                        ? "stickhandleone-five"
                        : "stick-color"
                    }
                  ></button>
                  <button
                    className={
                      activeStick === "stick_six"
                        ? "stickhandleone-five"
                        : "stick-color"
                    }
                  ></button>
                  <button
                    className={
                      activeStick === "stick_six"
                        ? "stickhandleone-five"
                        : "stick-color"
                    }
                  ></button>
                  <button
                    className={
                      activeStick === "stick_six"
                        ? "stickhandleone-five"
                        : "stick-color"
                    }
                  ></button>
                </div>
              </div>
            ) : null}
          </div>
          <div className="col-xl-6 col-lg-6 main-heading-inner-box">
            <div className="inner-box">
              <img src={leftTree} alt="img" className="heading-left-image" />
              <h3 className="main-heading-1">Special Products</h3>
              <img src={righttree} alt="img" className="heading-right-image" />
            </div>
          </div>
        </div>
        <div
          className={`row second_row mt-4 ${gridactive}`}
          style={{ justifyContent: "center" }}
        >
          {specialProducts && specialProducts.length > 0 ? (
            specialProducts.length >= 3 ? (
              <Slider {...sliderSettings}>
                {specialProducts.map((item, index) => (
                  <div className="grid_col" key={item.id || index}>
                    <Productgrid
                      productdetailslink={`/product-details/${item.id}`}
                      items={item}
                    />
                  </div>
                ))}
              </Slider>
            ) : specialProducts.length === 2 ? (
              specialProducts.map((item, index) => (
                <div
                  className="col-lg-3 col-md-4 col-sm-6"
                  key={item.id || index}
                >
                  <div className="grid_col">
                    <Productgrid
                      productdetailslink={`/product-details/${item.id}`}
                      items={item}
                    />
                  </div>
                </div>
              ))
            ) : specialProducts.length === 1 ? (
              specialProducts.map((item, index) => (
                <div
                  className="col-lg-3 col-md-4 col-sm-6 grid_div"
                  key={item.id || index}
                >
                  <div className="grid_col">
                    <Productgrid
                      productdetailslink={`/product-details/${item.id}`}
                      items={item}
                    />
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center">No Products  available</p>
            )
          ) : (
            <p className="text-center">No Products available</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default SpecialProducts;
